'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; desc = parent = getter = undefined; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _helpersSelectLocalVideo = require('./helpers/select-local-video');

var _helpersSelectLocalVideo2 = _interopRequireDefault(_helpersSelectLocalVideo);

var noop = function noop() {};

var Controls = (function (_React$Component) {
    _inherits(Controls, _React$Component);

    function Controls() {
        _classCallCheck(this, Controls);

        _get(Object.getPrototypeOf(Controls.prototype), 'constructor', this).apply(this, arguments);
    }

    _createClass(Controls, [{
        key: 'render',
        value: function render() {
            var playClassName = this.props.isPlaying ? 'fa fa-pause icon' : 'fa fa-play icon';
            var muteClassName = this.props.isMute ? 'fa fa-volume-off icon' : 'fa fa-volume-up icon';
            // <a className="open-remote fa fa-external-link icon" title="Open Remote"></a>
            return _react2['default'].createElement(
                'div',
                { className: 'video-controls' },
                _react2['default'].createElement('a', { className: playClassName, title: 'Play', onClick: this.playPause.bind(this) }),
                _react2['default'].createElement('input', { type: 'range', className: 'seek-bar', value: this.props.position, onChange: this.positionChange.bind(this), ref: 'seekBar' }),
                _react2['default'].createElement('a', { className: muteClassName, title: 'Mute', onClick: this.mute.bind(this) }),
                _react2['default'].createElement(
                    'span',
                    { className: 'brand' },
                    this.props.brand
                ),
                _react2['default'].createElement(
                    'span',
                    { className: 'info' },
                    this.props.title
                ),
                _react2['default'].createElement('span', { className: 'timingInfo' }),
                _react2['default'].createElement('a', { className: 'full-screen fa fa-expand icon rfloat', title: 'Full Screen', onClick: this.fullScreen.bind(this) }),
                _react2['default'].createElement('a', { className: 'select-local-file fa fa-folder-open icon rfloat', title: 'Select File', onClick: this.selectLocalFile.bind(this) })
            );
        }
    }, {
        key: 'playPause',
        value: function playPause() {
            this.props.onPlayPause();
        }
    }, {
        key: 'mute',
        value: function mute() {
            this.props.onMute();
        }
    }, {
        key: 'fullScreen',
        value: function fullScreen() {
            this.props.onFullScreen();
        }
    }, {
        key: 'positionChange',
        value: function positionChange() {
            this.props.onPositionChange(+this.refs.seekBar.value);
        }
    }, {
        key: 'selectLocalFile',
        value: function selectLocalFile() {
            var _this = this;

            (0, _helpersSelectLocalVideo2['default'])().then(function (videoFile) {
                _this.props.onLocalVideoSelected(videoFile);
            })['catch'](function (error) {
                console.error(error);
            });
        }
    }]);

    return Controls;
})(_react2['default'].Component);

Controls.propTypes = {
    isPlaying: _react.PropTypes.bool,
    onPlayPause: _react.PropTypes.func,
    isMute: _react.PropTypes.bool,
    onMute: _react.PropTypes.func,
    isFullscreen: _react.PropTypes.bool,
    onFullScreen: _react.PropTypes.func,
    position: _react.PropTypes.number,
    onPositionChange: _react.PropTypes.func,
    onLocalVideoSelected: _react.PropTypes.func,

    brand: _react.PropTypes.string,
    title: _react.PropTypes.string
};

Controls.defaultProps = {
    isPlaying: false,
    onPlayPause: noop,
    isMute: false,
    onMute: noop,
    isFullscreen: false,
    onFullScreen: noop,
    position: 0,
    onPositionChange: noop,
    onLocalVideoSelected: noop,
    brand: '',
    title: ''
};

exports['default'] = Controls;
module.exports = exports['default'];


/** WEBPACK FOOTER **
 ** ./~/babel-loader!./source/Controls.jsx
 **/